import React, {Component} from 'react'
import {Collapse} from 'react-bootstrap'
import './ParkingPassComponent.css'

export default class ParkingPassComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    openParkingPassDetails() {
        this.setState({
            open: !this.state.open
        });
    }

    render() {
        const {parkingPass} = this.props;
        return(
            <div className="panel panel-default">
                <div onClick={this.openParkingPassDetails.bind(this)} className="panel-heading taskHeader">
                    <div className="linkable">
                        <strong>Abbonamento Semplice</strong>
                        <div className="dataFinish pull-right">
                            <span>Scade il: </span>
                            <strong>10/11/2018</strong>
                        </div>

                    </div>
                </div>

                <Collapse in={this.state.open}>
                    <div className="panel-body">
                        <div className="row">
                            <div className="dettagli col-md-12">
                                <span style={{fontWeight:"bold"}}> Dettagli:</span>
                            </div>
                        </div>
                        <div className="notice slideOpen">

                            <h4>Valido dal 10/06/2017 al 09/07/2017</h4>
                            <div>Tipo abbonamento <strong>Generico</strong></div>
                            Con abbonamento semplice intendiamo prodotti che non vanno configurati o che non
                            necessitano di documentazione. Tramite autocertificazione l{'’'} utente sceglierà il tipo
                            di abbonamento desiderato.
                            Ad esempio abbonamento per residenti per zona geografica.
                            Questi prodotti saranno scelti dall{'’'} utente tramite elenco.

                            Sarà possibile acquistare questi abbonamenti su base MENSILE o SETTIMANALE.
                            Sarà possibile acquistare più mesi o settimane con una sola richiesta.

                            La durata dell{'’'}abbonamento è da intendersi {'in'} giorni solari.
                            30 giorni per il mensile e 7 per il settimanale.
                        </div>
                        <div className="noteContainer">
                            {JSON.stringify(parkingPass)}
                        </div>
                    </div>
                </Collapse>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ParkingPassComponent.js